import app from '@ratehub/web-server/src/pages/_app';
export default app;